import { get } from "react-hook-form";
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

const useMultiStepFormStore = create(
    devtools(
        persist(
            (set, get) => ({
                drafts: [],
                // activeDraftIdActiveStep: 1,
                addDraft: (draft) => set((state) => ({ ...state, drafts: [{ ...draft, updatedAt: new Date().toISOString() }, ...state.drafts] })),
                getDraftByDraftId: (draftId) => get().drafts.find((d) => d.draftId === draftId),

                upsertDraft: (updatedDraft) =>
                    set((state) => {
                        const updatedAt = new Date().toISOString()
                        //  console.log('updatedDraft', updatedDraft)
                        const drafts = state.drafts?.some((d) => d.draftId === updatedDraft.draftId)
                            ? state.drafts.map((exisitingDraft) => {
                                if (exisitingDraft.draftId === updatedDraft.draftId) {
                                    //       console.log('updating', updatedDraft)
                                    exisitingDraft = { ...exisitingDraft, ...updatedDraft, updatedAt };
                                }
                                return exisitingDraft;
                            })
                            : [...state.drafts, updatedDraft];


                        return {
                            ...state,
                            updatedAt,
                            // activeDraftId: updatedDraft.draftId,
                            // activeDraftIdActiveStep: updatedDraft.activeStep || state.activeDraftIdActiveStep,
                            drafts,
                        }
                    }),
                removeDraftByDraftId: (draftId) => set((state) => ({ ...state, drafts: state.drafts.filter((d) => d.draftId !== draftId) })),
            }),
            {
                name: "multistep-form",
            }
        )
    )
);

export { useMultiStepFormStore };
